/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import NewHeader from "./NewHeader";

export default NewHeader;
